module.exports = __webpack_public_path__ + "static/media/214x152_7 copy.67073441.png";